/* src/constants/topNav.js */
import { CDN } from '@/config/cdn'

const CDN_BASE = 'https://storage.googleapis.com/kironlite/mossbets/web/icons'

// Keep this list short and clean; duplicate in the layout if you
// want to artificially lengthen the track for scrolling demos.
export const TOP_NAV = [
  {
    name: 'aviator',
    label: 'Aviator',
    icon: `${CDN_BASE}/img-aviator-logo.png`,
  },
  {
    name: 'aviatrix',
    label: 'Aviatrix',
    icon: `${CDN_BASE}/img-aviatrix-logo.png`,
  },
  {
    name: 'instant-games',
    label: 'Instant Games',
    icon: `${CDN_BASE}/img-instant-league.png`,
  },
  {
    name: 'jetx',
    label: 'jetx',
    icon: `${CDN_BASE}/img-jetx-logo.png`,
  },
  {
    name: 'live',
    label: 'Live',
    icon: `${CDN_BASE}/img-logo-game.png`,
  },
  {
    name: 'box',
    label: 'Pick a Box',
    icon: `${CDN_BASE}/img-pick-a-box.png`,
    badge: CDN.icons('newtag-06.png'),
    badgeAlt: 'New',
  },
  {
    name: 'league',
    label: 'M League',
    icon: `${CDN_BASE}/img-mleague.png`,
    badge: CDN.icons('newtag-06.png'),
    badgeAlt: 'New',
  },
]
